import { withBrowserStorageCaching } from '@growth/browser-caching';
import { fetchPokusAssignVariantData } from '@growth/api-calls';
import { visitorIdBrowser } from '@growth/visitor-id/browser';

var getPokusAssignVariantClientData = function getPokusAssignVariantClientData(_ref) {
  var _ref$key = _ref.key,
    key = _ref$key === void 0 ? '' : _ref$key,
    pokusOptions = _ref.pokusOptions,
    _ref$extraHeader = _ref.extraHeader,
    extraHeader = _ref$extraHeader === void 0 ? {} : _ref$extraHeader,
    _ref$cache = _ref.cache,
    cache = _ref$cache === void 0 ? false : _ref$cache,
    _ref$cacheResponseKey = _ref.cacheResponseKeys,
    cacheResponseKeys = _ref$cacheResponseKey === void 0 ? [] : _ref$cacheResponseKey;
  /* make sure the visitor id is present in cookie before calling pokus */
  visitorIdBrowser();
  if (cache) return withBrowserStorageCaching({
    key: key,
    type: 'sessionStorage',
    asyncMethod: function asyncMethod() {
      return fetchPokusAssignVariantData({
        pokusOptions: pokusOptions,
        extraHeader: extraHeader
      });
    },
    ttl: 60,
    cacheResponseKeys: cacheResponseKeys
  });
  return fetchPokusAssignVariantData({
    pokusOptions: pokusOptions,
    extraHeader: extraHeader
  });
};

export { getPokusAssignVariantClientData };
